module.exports = __webpack_public_path__ + "static/media/harmonie-10.2cd7f34a.jpg";